export enum Placement {
Organic,
Temporary,
AdPersonam,
}
